
export default {
    getReport(authToken, {page, limit, filter, sort, columns}) {
        let reportUrl = this.prepareUrl(authToken, {page, limit, filter, sort, columns});

        return fetch(reportUrl)
            .then(async function(response) {
                if (!response.ok) {
                    const consumedResponse = await response.json();
                    throw Error(consumedResponse.error.description || response.statusText);
                }
                return response;
            })
            .then(data => data.json());
    },

    getCSVReport(authToken, {page, limit, filter, sort, columns}){
        const reportUrl = this.prepareUrl(authToken, {page, limit, filter, sort, columns});

        let formNode = document.createElement('form');
        formNode.method = 'POST';
        formNode.action = reportUrl;
        formNode.enctype = 'application/x-www-form-urlencoded';

        document.body.append(formNode);
        formNode.submit();
        formNode.destroy(true);
    },

    prepareUrl(authToken, {page, limit, filter, sort, columns}) {
        let reportUrl = `${APP_CONFIG.SHARED_REPORTS_URL}/shared-report/report/${authToken}?`;

        if(filter && filter.length) {
            reportUrl += '&filter=' + filter;
        }

        if(sort && sort.sortKey && sort.sortDirection) {
            reportUrl += `&sort=${sort.sortKey}&direction=${sort.sortDirection}`;
        }

        if (columns && columns.length) {
            reportUrl += '&columns=' + this.mapColumns(columns).join(',');
        }

        reportUrl += `&limit=${limit}`;
        reportUrl += `&offset=${(page - 1) * limit}`;
        return reportUrl;
    },

    mapColumns (columns) {
        let visibleColumns = columns.filter(column => column.visible);
        return visibleColumns.map(column => column.key);
    }
};



// WEBPACK FOOTER //
// ./src/services/ReportService.js